import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi, useAuth } from 'hooks';

type Payload = {
  userId: string;
  medicationId: string;
  active: boolean;
};

const useUpdateUserMedication = () => {
  const queryClient = useQueryClient();
  const { api } = useApi({ throwIfError: true });
  const { userToken } = useAuth();

  const mutation = useMutation({
    mutationFn: async ({ userId, medicationId, active }: Payload) => {
      return await api({
        route: `/private/dashboard/user/${userId}/medications/${medicationId}`,
        method: 'PATCH',
        token: userToken,
        payload: {
          active,
        },
      });
    },
    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({
        queryKey: ['user-medications', userToken, userId],
      });
      queryClient.invalidateQueries({
        queryKey: ['user-medications-prescriptions', userToken, userId],
      });
    },
  });

  return {
    mutation,
  };
};

export default useUpdateUserMedication;
